import { render, staticRenderFns } from "./CentraTraficoInspeccionForm.vue?vue&type=template&id=3ed096e4"
import script from "./CentraTraficoInspeccionForm.vue?vue&type=script&lang=js"
export * from "./CentraTraficoInspeccionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports